import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'neutral' | 'info';
  className?: string;
  onClick?: () => void;
}
export function Badge({
  children,
  variant = 'neutral',
  className = '',
  onClick
}: BadgeProps) {
  const variants = {
    success: 'bg-emerald-100 text-emerald-800',
    warning: 'bg-amber-100 text-amber-800',
    danger: 'bg-red-100 text-red-800',
    neutral: 'bg-slate-100 text-slate-800',
    info: 'bg-blue-100 text-blue-800'
  };
  const clickableStyles = onClick ? 'cursor-pointer hover:opacity-80 transition-opacity active:scale-95' : '';
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]} ${clickableStyles} ${className}`} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} onKeyDown={onClick ? e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  } : undefined} data-id="element-284">
      {children}
    </span>;
}